import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { checkOverviewExplanationsEnabled } from 'utils/helpers/featureFlags';
import { checkOneOnOneModuleEnabled } from 'utils/helpers/moduleAccess';

import { modifyString, StringModifier } from 'constants/copyHelpers';

export const useInitiativeTypeValues = () => {
  const { moduleName } = useOrganisationSettings();

  return [
    {
      text: `${modifyString(moduleName, StringModifier.TITLE_CASE)} initiatives`,
      id: 'GOAL',
      enabled: () => true,
    },
    {
      text: '1:1 initiatives',
      id: 'ONE_ON_ONE',
      enabled: () => checkOneOnOneModuleEnabled(),
    },
    {
      text: 'Competency initiatives',
      id: 'COMPETENCY_CHECKIN',
      enabled: () => true,
    },
    {
      text: 'Nudge initiatives',
      id: 'NUDGE_TASK',
      enabled: () => checkOverviewExplanationsEnabled(),
    },
  ];
};
